import { createPostAsyncSlice } from '@sonar-software/xuder';
import { postIssueVisibility } from '../../../api';
import { requestGetIssuesVisibleAgain } from '../../visible/actions';

export const postIssuesByIdVisibilitySlice = createPostAsyncSlice({
	httpSagaOptions: {
		successActionCreators: [ requestGetIssuesVisibleAgain ]
	},
	name: 'issuesByIdVisibility',
	receive: false,
	request: true,
	requestHandler: postIssueVisibility
});
